import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Util } from '../util.service';

@Injectable({
  providedIn: 'root'
})
export class QuestiondifficultyService {
  baseurl = Util.GetBaseUrl();

  constructor(private http: HttpClient, public router: Router) { }

  viewQuestionDifficulty() {
    return this.http.get(this.baseurl +'/api/QuestionDifficulties/GetQuestionDifficulties')
  }

  addQuestionDifficulty(questionDifficultyForm) {
    console.log(questionDifficultyForm);
    return this.http.post(this.baseurl+'/api/QuestionDifficulties/', questionDifficultyForm)
  }

  editQuestionDifficulty(id, questionDifficultyForm) {
    console.log(questionDifficultyForm);
    return this.http.put(this.baseurl +`/api/QuestionDifficulties/${id}`, questionDifficultyForm)
  }

  deleteQuestionDifficulty(id) {
    console.log(id);
    return this.http.delete(this.baseurl+`/api/QuestionDifficulties/${id}`)
  }
}
